import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { tokens } from '@hotjar/hotsauce';

interface SkeletonChildProps {
  size?: string;
}

const shimmer = keyframes`
  from {
    background-position: -1000px 0;
  }

  to {
    background-position: 1000px 0;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const SkeletonChild = styled.div<SkeletonChildProps>`
  background-image: linear-gradient(
    to right,
    ${tokens.BRAND_COLORS.neutral_100} 0%,
    ${tokens.BRAND_COLORS.neutral_200} 50%,
    ${tokens.BRAND_COLORS.neutral_100} 100%
  );
  background-repeat: repeat-x;
  background-size: 1000px 100%;
  border-radius: ${tokens.radius.m};
  animation: ${shimmer} 2s ease infinite;
`;

const SkeletonChildCircle = styled(SkeletonChild)`
  width: ${({ size }) => size || '1em'};
  height: ${({ size }) => size || '1em'};
  border-radius: ${({ size }) => size || '1em'};
`;

const SkeletonChildLine = styled(SkeletonChild)`
  width: 100%;
  height: ${({ size }) => size || '1em'};
  margin-bottom: 0.5em;
`;

/**
 * Future person: this function has been re-exported by packages/subscription-management,
 * if you extract this out of webapp into a standalone util please inform `@hotjar/monetization-platform` or `@hotjar/billing` FE so they are aware
 */
export function SkeletonLoader({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode | React.ReactNode[];
}): JSX.Element {
  return <Wrapper className={className}>{children}</Wrapper>;
}

SkeletonLoader.Circle = SkeletonChildCircle;
SkeletonLoader.Line = SkeletonChildLine;
